import { render, staticRenderFns } from "./CardAnalyticCustomers.vue?vue&type=template&id=64d613d8&"
import script from "./CardAnalyticCustomers.vue?vue&type=script&lang=js&"
export * from "./CardAnalyticCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports